module.exports = __webpack_public_path__ + "img/aratarea-credintei-1715-pagina-de-titlu-big.820f3169.jpg";